module.exports = __webpack_public_path__ + "static/media/away.659e97dd.jpg";